import styled from '../../../theme'

const ModalWrapper = styled.div`
  position: absolute;
  top: 20vh;
  width: 60vw;
  left: 50%;
  transform: translateX(-50%);

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    width: 95vw;
    top: 10vh;
  }
`

export default ModalWrapper
